module.exports = __webpack_public_path__ + "img/192.243643ed.svg";